import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import { addToTrackingBoardUtilityStateAtom } from './AddToTrackingBoardUtility.state';

export function useAddToTrackingBoardUtility() {
  const setAddToBoardState = useSetRecoilState(
    addToTrackingBoardUtilityStateAtom,
  );

  const openAddToTrackingBoardUtility = useCallback(() => {
    setAddToBoardState({ open: true });
  }, [setAddToBoardState]);

  const closeAddToTrackingBoardUtility = useCallback(() => {
    setAddToBoardState({ open: false });
    requestAnimationFrame(() => {
      if (
        document.activeElement &&
        typeof document.activeElement.blur === 'function'
      ) {
        document.activeElement.blur();
      }
    });
  }, [setAddToBoardState]);

  return {
    openAddToTrackingBoardUtility,
    closeAddToTrackingBoardUtility,
  };
}
